import React from 'react';
import { SubscribeButton } from './SubscribeButton';
import { channel } from '../data/channel';
export function SubscribeBand() {
  return <section aria-labelledby="subscribe-title" className="bg-ember text-ember-ink" data-id="element-147" data-mp="y7m3dloyr0kj">
      <div className="mx-auto grid max-w-7xl items-end gap-10 px-5 py-20 md:px-8 md:py-24 lg:grid-cols-12" data-id="element-148" data-mp="kg7n3mmfxdh6">
        <div className="lg:col-span-8" data-id="element-149" data-mp="oh1b0fzvusa2">
          <h2 id="subscribe-title" className="font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-150" data-mp="1c6c0h1bs908w">
            Наступна пригода вже в дорозі.
          </h2>
          <p className="mt-5 max-w-xl text-lg font-medium leading-relaxed text-ember-ink/80" data-id="element-151" data-mp="13674rofybqak">
            Нас уже понад тисяча. Підпишіться на {channel.name} і натисніть дзвіночок, щоб не пропустити нове
            відео. Це безкоштовно і дуже допомагає каналу рости.
          </p>
        </div>
        <div className="lg:col-span-4 lg:justify-self-end" data-id="element-152" data-mp="3sv97mpj9ip7f">
          <SubscribeButton size="lg" variant="ink" label="Підписатися на YouTube" data-id="element-153" data-mp="3ssd66r87hie8" />
        </div>
      </div>
    </section>;
}